import { render } from "./top_bar.vue?vue&type=template&id=38e6bf20"
import script from "./top_bar.vue?vue&type=script&lang=js"
export * from "./top_bar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__